var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "play_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.333 3.41v5.18c0 .395.435.635.77.42l4.07-2.59a.5.5 0 0 0 0-.845L5.103 2.99a.499.499 0 0 0-.77.42Z",
    fill: "currentColor"
  })));
};
export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTMgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNC4zMzMzNyAzLjQxVjguNTlDNC4zMzMzNyA4Ljk4NSA0Ljc2ODM3IDkuMjI1IDUuMTAzMzcgOS4wMUw5LjE3MzM3IDYuNDJDOS40ODMzNyA2LjIyNSA5LjQ4MzM3IDUuNzc1IDkuMTczMzcgNS41NzVMNS4xMDMzNyAyLjk5QzQuNzY4MzcgMi43NzUgNC4zMzMzNyAzLjAxNSA0LjMzMzM3IDMuNDFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";